import SSProductDetailLine, {
  type IProductDetailLineProps,
} from "@core-components/product-detail-line/ProductDetailLine";
import { Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";

interface IDiscoverCardProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  detailLinesProps: IProductDetailLineProps[];
  button: ReactNode;
}

const SSDiscoverCard: React.FC<IDiscoverCardProps> = ({
  detailLinesProps,
  icon,
  subtitle,
  button,
  title,
}) => {
  return (
    <Stack
      align="center"
      className="hover-scale h-full w-[95%] rounded-[16px] bg-primary-darker p-8 text-primary-white"
      maw={320}
    >
      {icon}
      <Title className="font-secret-black" order={3} size={30}>
        {title}
      </Title>
      <Text className="h-10 text-center font-inter font-normal text-primary-dark-text">
        {subtitle}
      </Text>
      <div className="mt-5 w-full grow space-y-4">
        {detailLinesProps.map((props, index) => (
          <SSProductDetailLine key={index} {...props} />
        ))}
      </div>
      {button}
    </Stack>
  );
};

export default SSDiscoverCard;
